import React from 'react';
import { PropTypes } from 'prop-types';

const ToggleSwitch = ({ label = '', isEnabled = false, onChange }) => {
  return (
    <label className="toggle-switch">
      {label}
      <input id="toggleSwitch" type="checkbox" checked={isEnabled} onChange={onChange} />
      <span className="switch" />
    </label>
  );
};

ToggleSwitch.propTypes = {
  label: PropTypes.string,
  isEnabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default ToggleSwitch;
